<template>
  <b-modal
    id="modal-questionsSequence"
    title="Dolžina sekvence"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="white"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="login">
          <b-form-row class="mb-3 justify-content-center">
            <b-col cols="12">
              <b-alert variant="warning" show>
                <font-awesome-icon
                  size="lg"
                  icon="exclamation-circle"
                  class="text-warning mb-1 mx-auto d-block"
                />
                <em
                  >Pozor: v primeru idealnih sekvenc se to ne upošteva. Velja
                  zgolj za naključno izbrane pare.
                </em>
              </b-alert>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Nastavi št. vprašanj v sekvenci">
                <b-form-input
                  id="range-1"
                  v-model="form.questionsSequence"
                  type="range"
                  min="5"
                  max="50"
                  step="5"
                ></b-form-input>

                <div class="mt-3">
                  Izbrano: <strong>{{ form.questionsSequence }}</strong>
                </div>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-questionsSequence')"
        class="btn btn-muted btn-md"
      >
        Prekliči
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Nastavi dolžino sekvence
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      isSending: false,
      options: [
        { text: "2 cards in matchup", value: 2 },
        { text: "3 cards in matchup", value: 3 },
        { text: "4 cards in matchup", value: 4 },
      ],
      form: {
        questionsSequence: 10,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      let projectId = this.$store.state.api.selectedProject.id;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/projects/${projectId}/questions/${this.form.questionsSequence}`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          method: "POST",
        })
          .then((response) => {
            this.isSending = false;
            this.$bvModal.hide("modal-questionsSequence");
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
            // TODO: REMOVE THIS FOR PRODUCTION
            setTimeout(() => {
              this.$router.go();
            }, 1000);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
